import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cn from 'classnames';
import { Link } from 'react-router-dom';

import NotyInfoIcon from '../../../../assets/icons/common/notifications/NotyInfoIcon';
import NotyErrorIcon from '../../../../assets/icons/common/notifications/NotyErrorIcon';
import NotySuccessIcon from '../../../../assets/icons/common/notifications/NotySuccessIcon';
import NotyWarningIcon from '../../../../assets/icons/common/notifications/NotyWarningIcon';
import CloseIcon from '../../../../assets/icons/common/CloseIcon';
import Button from '../Button';
import { hideNotification } from '../../../../redux/notificationsSlice';
import { SUPPORT } from '../../../../routes';

import styles from './styles.module.scss';

const Notification = () => {
  const dispatch = useDispatch();
  const notification = useSelector((state) => state.notifications);
  const { isShown, type, value, disableAutoClose, closeTimeout } = notification;

  const closeNoty = () => {
    dispatch(hideNotification());
  };

  useEffect(() => {
    let timerId;
    if (isShown && !disableAutoClose) {
      timerId = setTimeout(() => {
        dispatch(hideNotification());
      }, closeTimeout);
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, isShown]);

  const renderIcon = () => {
    switch (type) {
      case 'success':
        return <NotySuccessIcon />;
      case 'warning':
        return <NotyWarningIcon />;
      case 'error':
        return <NotyErrorIcon />;
      default:
        return <NotyInfoIcon />;
    }
  };

  return (
    <div className={styles.wrapper}>
      <div
        className={cn(styles.noty, styles[type], { [styles.hidden]: !isShown })}
      >
        <p className={styles.value}>
          {renderIcon()}
          {value}
        </p>
        {type === 'error' && (
          <div className={styles.buttonsWrapper}>
            <Link to={SUPPORT}>
              <Button className={styles.button}>Need Help?</Button>
            </Link>
            <button onClick={closeNoty} className={styles.closeCircle}>
              <CloseIcon />
            </button>
          </div>
        )}
        {type !== 'error' && (
          <button onClick={closeNoty} className={styles.closeCircle}>
            <CloseIcon />
          </button>
        )}
      </div>
    </div>
  );
};

export default Notification;
